import WorkIcon from '@mui/icons-material/Work';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import DiamondIcon from '@mui/icons-material/Diamond';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import FlightIcon from '@mui/icons-material/Flight';
import SchoolIcon from '@mui/icons-material/School';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HomeIcon from '@mui/icons-material/Home';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export const GENDER_OPTIONS = ['Male', 'Female'];

export const AGE_OPTIONS = ['18-25', '26-35', '36-45', '45+'];

export const INCOME_GROUP_OPTIONS = [
  { value: 'sec_a_plus', label: 'SEC A+' },
  { value: 'sec_a', label: 'SEC A' },
  { value: 'sec_b', label: 'SEC B' },
  { value: 'sec_c', label: 'SEC C' },
];

export const AFFINITY_OPTIONS = [
  {
    value: 'Corporate Professionals',
    label: 'Corporate Professionals',
    icon: BusinessCenterIcon,
  },
  {
    value: 'Executive & Business Leaders',
    label: 'Executive & Business Leaders',
    icon: WorkIcon,
  },
  {
    value: 'Tech & IT Workforce',
    label: 'Tech & IT Workforce',
    icon: WorkIcon,
  },
  {
    value: 'Affluent & HNI',
    label: 'Affluent & HNI',
    icon: DiamondIcon,
  },
  {
    value: 'Residents & Locals',
    label: 'Residents & Locals',
    icon: HomeIcon,
  },
  {
    value: 'Daily Commuters & Flow',
    label: 'Daily Commuters & Flow',
    icon: DirectionsCarIcon,
  },
  {
    value: 'Shoppers & Retail Visitors',
    label: 'Shoppers & Retail Visitors',
    icon: ShoppingBagIcon,
  },
  {
    value: 'Students & Youth',
    label: 'Students & Youth',
    icon: SchoolIcon,
  },
  {
    value: 'Travelers & Tourists',
    label: 'Travelers & Tourists',
    icon: FlightIcon,
  },
  {
    value: 'Specialized & Government Personnel',
    label: 'Specialized & Government Personnel',
    icon: AccountBalanceIcon,
  },
];

export const SCREEN_TYPES = [
  'Secondary',
  'High street',
  'Commercial',
  'Corporate park',
  'Airport',
  'Office Cum Mall',
  'Outdoor',
  'Residential',
  'Coworking space',
  'Corporate',
  'residential',
  'Mall',
];
